"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lerp_array_1 = __importDefault(require("lerp-array"));
var utils_1 = require("./utils");
var utils_2 = require("./utils");
exports.isColor = utils_2.isColor;
var lerpColor = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length === 1) {
        var colors_1 = args[0];
        var parsedColors_1 = colors_1.map(utils_1.parseColor);
        return function (t) {
            var _a = utils_1.getStep(parsedColors_1, t), step = _a[0], time = _a[1];
            var start = colors_1[step];
            var end = colors_1[step + 1];
            if ((time === 0 || start === end) && !utils_1.rgbaHexColorRegex.test(start)) {
                return start;
            }
            if (time === 1 && !utils_1.rgbaHexColorRegex.test(end)) {
                return end;
            }
            var startColor = parsedColors_1[step];
            var endColor = parsedColors_1[step + 1];
            if (startColor && endColor) {
                return utils_1.stringifyColor(lerp_array_1.default(startColor, endColor, time), end);
            }
            return undefined;
        };
    }
    else {
        var colors = args.length === 2 ? args[0] : args.slice(0, args.length - 1);
        var _a = utils_1.getStep(colors, args[args.length - 1]), step = _a[0], time = _a[1];
        var start = colors[step];
        var end = colors[step + 1];
        if ((time === 0 || start === end) && !utils_1.rgbaHexColorRegex.test(start)) {
            return start;
        }
        if (time === 1 && !utils_1.rgbaHexColorRegex.test(end)) {
            return end;
        }
        var startColor = utils_1.parseColor(start);
        var endColor = utils_1.parseColor(end);
        if (startColor && endColor) {
            return utils_1.stringifyColor(lerp_array_1.default(startColor, endColor, time), end);
        }
    }
    return undefined;
};
exports.default = lerpColor;
